import { render, staticRenderFns } from "./Invitations.vue?vue&type=template&id=38eb2d3d&"
import script from "./Invitations.vue?vue&type=script&lang=ts&"
export * from "./Invitations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports